<div #body class="flex h-full flex-col">
  <header class="bg-noir-1 relative flex items-center px-5 shrink-0" style="height: 75px">
    <div (click)="openHomePage()" class="flex items-center w-[200px] shrink-0 cursor-pointer">
      <span class="text-[25px] font-bold leading-none">
        <span class="logo-container">
          <img src="/assets/images/logo/MealCheckWhite.webp" alt="Logo MealCheck" class="logo" />
        </span>
      </span>
    </div>

    <div class="flex-1"></div>

    <div class="pointer-events-none absolute inset-x-0 top-1/2 -translate-y-1/2 flex justify-center px-5">
      <div class="pointer-events-auto flex flex-col items-center gap-[4px]">
        <div class="flex items-center gap-[10px]">
          @if (mealMoment()) {
          <span class="text-white text-[20px] font-bold leading-none">
            {{ mealMoment() | capitalize }}
          </span>
          <div class="size-[5px] rounded-full bg-white shrink-0"></div>
          }
          <span class="text-white text-[20px] font-bold leading-none">
            {{ date() | capitalize }}
          </span>
        </div>

        <div class="flex items-center gap-[10px]">
          @for (item of getCenterItems(); track item; let last = $last) {
          @switch (item) {
          @case ('location') {
          <span class="text-white text-[20px]">{{
            headerConfig.locationText | capitalize
            }}</span>
          }
          @case ('cashRegister') {
          <span class="text-white text-[20px]">{{
            headerConfig.cashRegisterText | capitalize
            }}</span>
          }
          @case ('status') {
          <div [class]="statusClass" class="flex items-center gap-[5px] h-[30px] px-[10px] rounded-[16px]">
            <div [class]="statusIconColor" class="size-[5px] rounded-full shrink-0"></div>
            <span class="text-white text-[14px] font-semibold whitespace-nowrap">
              {{ statusText() | translate }}
            </span>
          </div>
          }
          }

          @if (!last) {
          <div class="size-[5px] rounded-full bg-white shrink-0"></div>
          }
          }
        </div>
      </div>
    </div>

    <div class="flex items-center gap-[20px] shrink-0">
      @if (headerConfig.showUserMenu && user(); as currentUser) {
      <div class="relative">
        <button
          class="bg-noir-2-contour border border-[#494949] h-[58px] w-[173px] rounded-[5px] flex items-center px-[12px] gap-[8px] cursor-pointer hover:bg-[#555555] transition-colors"
          type="button" (click)="toggleUserDropdown($event)">
          <div class="bg-orange-1 rounded-full size-[33px] flex items-center justify-center shrink-0">
            <span class="text-white text-[14px] font-bold">{{ getUserInitials(currentUser) }}</span>
          </div>
          <span class="text-white text-[16px] font-semibold whitespace-nowrap flex-1 min-w-0 truncate text-left">
            {{ getUserDisplayName(currentUser) }}
          </span>
          <svg width="10" height="6" viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg" class="shrink-0"
            [class.rotate-180]="showUserDropdown()">
            <path d="M1 1L5 5L9 1" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
          </svg>
        </button>

        @if (showUserDropdown()) {
        <div
          class="absolute right-0 top-[calc(100%+8px)] bg-noir-2-contour border border-noir-2 rounded-[5px] min-w-full overflow-hidden z-50">
          @if (showCloseSessionButton()) {
          <button
            class="w-full flex items-center gap-[10px] px-[12px] py-[12px] text-white text-[14px] font-semibold hover:bg-[#555555] transition-colors cursor-pointer"
            type="button" (click)="closeSession()">
            <app-svg class="shrink-0" height="18" svgPath="assets/svg/close-circle.svg" width="18" />
            {{ 'close_session.title' | translate }}
          </button>
          }
          <button
            class="fg-rose-2 w-full flex items-center gap-[10px] px-[12px] py-[12px] text-white text-[14px] font-semibold hover:bg-[#555555] transition-colors cursor-pointer"
            type="button" (click)="logout()">
            <app-svg class="fg-rose-2 shrink-0" height="18" svgPath="assets/svg/logout.svg" width="18" />
            {{ 'common.to_logout' | translate }}
          </button>

          @if (version || buildDate || lastPipeline) {
          <div class="border-t border-noir-2 px-[12px] py-[10px] text-[12px] fg-gris-1 space-y-[2px]">
            @if (version) {
            <p>{{ 'user_preferences.about.version_label' | translate }} : {{ version }}</p>
            }
            @if (buildDate) {
            <p>{{ 'user_preferences.about.build_date_label' | translate }} : {{ buildDate }}</p>
            }
            @if (lastPipeline) {
            <p>{{ 'user_preferences.about.last_pipeline_label' | translate }} : {{ lastPipeline }}</p>
            }
          </div>
          }
        </div>
        }
      </div>
      }

      @if (headerConfig.showDeliveryButton) {
      <button
        class="bg-noir-2-contour size-[58px] rounded-[5px] flex items-center justify-center cursor-pointer hover:bg-[#555555] transition-colors shrink-0"
        type="button" (click)="listOrders()">
        <app-svg class="fg-gris-2" height="28" svgPath="assets/svg/list.svg" width="28" />
      </button>
      }

      @if (headerConfig.showPreferencesButton) {
      <button
        class="bg-noir-2-contour size-[58px] rounded-[5px] flex items-center justify-center cursor-pointer hover:bg-[#555555] transition-colors shrink-0"
        type="button" (click)="togglePreferencesModal()">
        <app-svg class="fg-gris-2" height="28" svgPath="assets/svg/accessibility.svg" width="28" />
      </button>
      }

      @if (headerConfig.showSettingsButton) {
      <button
        class="bg-noir-2-contour size-[58px] rounded-[5px] flex items-center justify-center cursor-pointer hover:bg-[#555555] transition-colors shrink-0"
        type="button" (click)="openSettings()">
        <app-svg class="fg-gris-2" height="28" svgPath="assets/svg/settings.svg" width="28" />
      </button>
      }
    </div>
  </header>

  <div class="flex-1 h-full overflow-hidden">
    <router-outlet></router-outlet>
  </div>
</div>

@if (showPreferencesModal()) {
<app-modal-user-preferences (requestClose)="closePreferencesModal()" />
}

@if (showReauthModal()) {
<div class="fixed inset-0 z-50 flex items-center justify-center bg-black/30">
  <app-modal-reauth (cancelClick)="onReauthCancel()" (success)="onReauthSuccess()" />
</div>
}

@if (showTenantMismatchModal()) {
<div class="fixed inset-0 z-50 flex items-center justify-center bg-black/30">
  <app-modal-card class="w-[500px]">
    <p class="text-[68px] leading-none" aria-hidden="true">⚠️</p>

    <p class="text-[19px] font-semibold fg-noir-1 text-center mt-[28px]">
      {{ 'modal.tenant_mismatch.title' | translate }}
    </p>

    <p class="text-[14px] fg-gris-1 text-center mt-[12px] whitespace-pre-line">
      {{ 'modal.tenant_mismatch.subtitle' | translate }}
    </p>

    <div class="flex gap-[10px] w-[400px] mt-auto">
      <button
        type="button"
        class="border border-gris-3 rounded-[5px] h-[58px] px-5 flex items-center gap-[10px] fg-noir-2 text-[16px] font-medium cursor-pointer hover:bg-gris-4 transition-colors"
        (click)="onTenantMismatchCancel()"
      >
        {{ 'common.cancel' | translate }}
        <app-svg svgPath="assets/svg/close-circle.svg" width="20" height="20" />
      </button>
      <button
        type="button"
        class="h-[58px] w-full px-[20px] flex items-center justify-center bg-vert-1 rounded-[5px] text-[16px] font-semibold fg-blanc cursor-pointer"
        (click)="onTenantMismatchConfirm()"
      >
        {{ 'common.confirm' | translate }}
      </button>
    </div>
  </app-modal-card>
</div>
}